import { supabase } from './supabaseClient';
import { getLocalDateString } from './dateTimeFormatting';

export async function debugCheckLots() {
  console.log('=== Checking resource_lots in database ===');
  
  const { data: lots, error } = await supabase
    .from('resource_lots')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(10);
  
  if (error) {
    console.error('❌ Error fetching lots:', error);
    return;
  }
  
  if (!lots || lots.length === 0) {
    console.log('❌ No lots found in database');
  } else {
    console.log(`✅ Found ${lots.length} lots in database:`);
    lots.forEach((lot: any) => {
      console.log('---');
      console.log('Lot Number:', lot.lot_number);
      console.log('Resource ID:', lot.resource_id);
      console.log('Purchase Qty:', lot.purchase_total_uoms, lot.purchase_quantity_uom);
      console.log('Created:', lot.created_at);
    });
  }
}

export async function debugTestInsert() {
  console.log('=== Testing direct insert to resource_lots ===');
  
  // Test with minimal required fields
  const testLot = {
    resource_id: '21156100-28d9-4ee5-a124-9a5273ddda3a', // Using the ID from your logs
    tenant_id: '01234567-89ab-cdef-0123-456789abcdef',
    lot_number: `TEST-${Date.now()}`,
    received_date: getLocalDateString(),
    purchase_qty_per_unit: 1,
    purchase_total_units: 1,
    purchase_total_uoms: 1,
    purchase_quantity_uom: 'oz',
    purchase_subtotal: 10,
    purchase_total_cost: 10,
    current_total_units: 1,
    current_total_uoms: 1,
  };
  
  console.log('Attempting to insert:', testLot);
  
  const { data, error } = await supabase
    .from('resource_lots')
    .insert([testLot])
    .select();
  
  if (error) {
    console.error('❌ Insert failed:', error);
    console.error('Error details:', {
      message: error.message,
      details: error.details,
      hint: error.hint,
      code: error.code
    });
  } else {
    console.log('✅ Insert successful:', data);
  }
}

export async function debugCheckPermissions() {
  console.log('=== Checking table permissions ===');
  
  // Check if we can read from resources
  const { data: resources, error: resourceError } = await supabase
    .from('resources')
    .select('id')
    .limit(1);
  
  if (resourceError) {
    console.error('❌ Cannot read from resources table:', resourceError);
  } else {
    console.log('✅ Can read from resources table');
  }
  
  // Check if we can read from resource_lots
  const { data: lots, error: lotsError } = await supabase
    .from('resource_lots')
    .select('id')
    .limit(1);
  
  if (lotsError) {
    console.error('❌ Cannot read from resource_lots table:', lotsError);
  } else {
    console.log('✅ Can read from resource_lots table');
  }
  
  // Check current user
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  
  if (userError) {
    console.error('❌ Cannot get current user:', userError);
  } else {
    console.log('✅ Current user:', user?.id || 'Anonymous');
  }
}

// Make functions available on window for debugging
if (typeof window !== 'undefined') {
  (window as any).debugCheckLots = debugCheckLots;
  (window as any).debugTestInsert = debugTestInsert;
  (window as any).debugCheckPermissions = debugCheckPermissions;
}